// import React, { useEffect, useState } from 'react';
// import Layout from '../layout/Layout';
// import PageTransition from '../components/PageTransition';
// import { getSubscriptionAnalytics } from '../components/DbServices';

// export default function SubscriptionReport() {
//   const [data, setData] = useState({ subscriptions: [], chartData: [], totalRevenue: 0 });
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchAnalytics();
//   }, []);

//   const fetchAnalytics = async () => {
//     const res = await getSubscriptionAnalytics();
//     if (res.status === 200) setData(res);
//     setLoading(false);
//   };

//   return (
//     <Layout>
//       <PageTransition>
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="fw-bold">Financial Analytics</h3>
//           <div className="badge bg-success-subtle text-success p-2 px-3 rounded-pill">
//             Net Revenue: Rs.{data.totalRevenue.toFixed(2)}
//           </div>
//         </div>

//         {/* ANALYTICS CARDS */}
//         <div className="row mb-4">
//           <div className="col-md-8">
//             <div className="card border-0 shadow-sm rounded-4 p-4 h-100">
//               <h6 className="fw-bold mb-4">7-Day Revenue Trend</h6>
//               <div className="d-flex align-items-end justify-content-between" style={{ height: '150px' }}>
//                 {data.chartData.map((day, i) => (
//                   <div key={i} className="text-center" style={{ width: '12%' }}>
//                     <div className="bg-primary rounded-top" style={{ 
//                         height: `${(day.revenue / data.totalRevenue) * 500 + 20}px`, 
//                         opacity: 0.8 
//                     }}></div>
//                     <div className="x-small mt-2 text-muted" style={{ fontSize: '0.6rem' }}>{day.date}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//           <div className="col-md-4">
//              <div className="card border-0 shadow-sm rounded-4 p-4 bg-dark text-white h-100">
//                 <h6 className="fw-bold opacity-75">Quick Stats</h6>
//                 <div className="mt-4">
//                     <h2 className="fw-bold text-info">{data.subscriptions.length}</h2>
//                     <p className="small opacity-50 text-uppercase">Total Subscriptions</p>
//                 </div>
//                 <hr className="opacity-25" />
//                 <div>
//                     <h2 className="fw-bold text-success">Rs.{(data.totalRevenue / 30).toFixed(2)}</h2>
//                     <p className="small opacity-50 text-uppercase">Average Daily Revenue</p>
//                 </div>
//              </div>
//           </div>
//         </div>

//         {/* DETAILED SUBSCRIPTION TABLE */}
//         <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
//           <div className="p-4 border-bottom">
//             <h6 className="fw-bold mb-0">Subscription Log</h6>
//           </div>
//           <div className="table-responsive">
//             <table className="table table-hover align-middle mb-0">
//               <thead className="bg-light small text-uppercase">
//                 <tr>
//                   <th className="ps-4">User</th>
//                   <th>Plan</th>
//                   <th>Amount</th>
//                   <th>Limit</th>
//                   <th>Expires At</th>
//                   <th className="pe-4 text-end">Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.subscriptions.map((sub) => (
//                   <tr key={sub.id}>
//                     <td className="ps-4">
//                       <div className="fw-bold small">{sub.user_name}</div>
//                       <div className="text-muted" style={{ fontSize: '0.7rem' }}>{sub.email}</div>
//                     </td>
//                     <td><span className="badge bg-light text-dark border">{sub.plan_name}</span></td>
//                     <td className="fw-bold text-success">Rs.{sub.price}</td>
//                     <td className="small">{sub.message_limit} Msg</td>
//                     <td className="small">{sub.expires_at}</td>
//                     <td className="pe-4 text-end">
//                       <span className={`badge ${new Date(sub.expires_at) > new Date() ? 'bg-success' : 'bg-danger'}`}>
//                         {new Date(sub.expires_at) > new Date() ? 'Active' : 'Expired'}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </PageTransition>
//     </Layout>
//   );
// }


import React, { useEffect, useState } from 'react';
import Layout from '../layout/Layout';
import PageTransition from '../components/PageTransition';
import { getSubscriptionAnalytics } from '../components/DbServices';
import Swal from 'sweetalert2';

export default function SubscriptionReport() {
  const [data, setData] = useState({ subscriptions: [], chartData: [], totalRevenue: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    const res = await getSubscriptionAnalytics();
    
    debugger
    if (res.status === 200) 
    {
      debugger
      setData(res.data || res);
      debugger
    }
      
    setLoading(false);
  };

  return (
    <Layout>
      <PageTransition>
        <div className="container-fluid py-4">
          
          {/* HEADER SECTION - Back to your finalized style */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1"><span className="color-theme">Financial Analytics</span> 💰</h3>
              <p className="text-muted small fw-medium">Monitor revenue and subscription logs.</p>
            </div>
            <div className="d-flex gap-2">
                <div className="badge bg-success-subtle text-success p-2 px-3 rounded-pill d-flex align-items-center border border-success-subtle">
                   <span className="fw-bold">Net Revenue: Rs.{data.totalRevenue.toFixed(2)}</span>
                </div>
                <button className="btn btn-primary btn-sm rounded-3 shadow-sm px-3" onClick={() => window.print()}>
                   <i className="fas fa-print me-2"></i> Print Report
                </button>
            </div>
          </div>

          {/* METRICS SUMMARY - Using your finalized MetricCard style */}
          <div className="row mb-4">
            <MetricCard title="Total Subscriptions" value={data.subscriptions.length} icon="fa-receipt" color="primary" />
            <MetricCard title="Avg. Daily Revenue" value={`Rs.${(data.totalRevenue / 30).toFixed(2)}`} icon="fa-chart-line" color="success" />
            <MetricCard title="Active Plans" value={data.subscriptions.filter(s => new Date(s.expires_at) > new Date()).length} icon="fa-check-double" color="info" />
          </div>

          {/* TABLE DATA - Restored to your exact table structure */}
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light text-muted small text-uppercase">
                  <tr>
                    <th className="ps-4 py-3">Subscriber</th>
                    <th>Plan</th>
                    <th>Amount</th>
                    <th>Expires At</th>
                    <th className="pe-4 py-3 text-end">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="5" className="text-center py-5 text-muted">Loading Analytics...</td></tr>
                  ) : (
                    data.subscriptions.map((sub) => {
                      const isActive = new Date(sub.expires_at) > new Date();
                      return (
                        <tr key={sub.id} className="border-bottom border-light">
                          <td className="ps-4 py-3">
                            <div className="d-flex align-items-center gap-3">
                              <div className="rounded-4 bg-primary text-white d-flex align-items-center justify-content-center shadow-sm" style={{ width: '42px', height: '42px' }}>
                                <i className="fas fa-user small"></i>
                              </div>
                              <div>
                                <div className="fw-bold text-dark small mb-0">{sub.user_name}</div>
                                <div className="text-muted" style={{ fontSize: '11px' }}>{sub.email}</div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-light text-dark border px-2 py-1" style={{ fontSize: '10px' }}>
                                {sub.plan_name}
                            </span>
                          </td>
                          <td>
                            <div className="fw-bold text-success small">Rs.{sub.price}</div>
                          </td>
                          <td className="small text-muted">{sub.expires_at}</td>
                          <td className="pe-4 text-end">
                             <span className={`badge rounded-pill fw-bold ${isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} px-3 py-2`} style={{ fontSize: '10px' }}>
                                <span className={`pulse-dot me-2 ${isActive ? 'bg-success' : 'bg-danger'}`}></span>
                                {isActive ? 'ACTIVE' : 'EXPIRED'}
                             </span>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </PageTransition>
    </Layout>
  );
}

// Fixed MetricCard component to match your layout
function MetricCard({ title, value, icon, color }) {
  return (
    <div className="col-md-4">
      <div className="card border-0 shadow-sm rounded-4 p-3 bg-white">
        <div className="d-flex align-items-center">
          <div className={`bg-${color}-subtle text-${color} p-3 rounded-circle me-3`}>
            <i className={`fas ${icon} fa-lg`}></i>
          </div>
          <div>
            <div className="text-muted small fw-bold text-uppercase">{title}</div>
            <h4 className="fw-bold mb-0">{value}</h4>
          </div>
        </div>
      </div>
    </div>
  );
}